module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-3.svg?c0e46c4b74bca830a1cc95c71147b254";